import { z } from 'zod'

const envSchema = z
  .object({
    DEV: z.boolean(),
    PROD: z.boolean(),
    REACT_APP_API_URL:
      import.meta.env.MODE === 'test'
        ? z.string().optional().default('/')
        : z.string().url(),
    REACT_APP_IBGE_API_URL:
      import.meta.env.MODE === 'test'
        ? z.string().optional().default('/')
        : z.string().url(),
    REACT_APP_SOFTWARE_VERSION: z.string().optional(),
    REACT_APP_ENABLE_PREVIOUS_FEATURES: z
      .string()
      .toLowerCase()
      .optional()
      .transform((x) => x === 'true'),
    REACT_APP_ATLAS_PROJECT_ID: z.string().optional(),
    REACT_APP_HOTJAR_ID: z.coerce.number().optional(),
    REACT_APP_HOTJAR_SNIPPET_VERSION: z.coerce.number().optional(),
    REACT_APP_CLOUD_GEO_KEY: z.string().optional(),
    REACT_APP_SENTRY_DSN: z.string().url().optional(),
    REACT_APP_SENTRY_ENV: z.enum(['dev', 'beta', 'prod']).optional(),
  })
  .transform((env) => ({
    isDev: env.DEV,
    isProd: env.PROD,
    apiURL: env.REACT_APP_API_URL,
    ibgeApiURL: env.REACT_APP_IBGE_API_URL,
    softwareVersion: env.REACT_APP_SOFTWARE_VERSION,
    enablePreviousFeatures: env.REACT_APP_ENABLE_PREVIOUS_FEATURES,
    atlasProjectId: env.REACT_APP_ATLAS_PROJECT_ID,
    hotjarId: env.REACT_APP_HOTJAR_ID,
    hotjarSV: env.REACT_APP_HOTJAR_SNIPPET_VERSION,
    googleApiKey: env.REACT_APP_CLOUD_GEO_KEY,
    sentryDsn: env.PROD ? env.REACT_APP_SENTRY_DSN : undefined,
    sentryEnv: env.REACT_APP_SENTRY_ENV,
  }))

export const env = envSchema.parse(import.meta.env)
